import React from "react";
import styles from "../price-layout/price-layout.module.scss";
import { formatCurrency } from "../../../utils/utils";
import PriceDropTag from "../../common/pricedrop-tag";

const PriceLayout = ({
  amount,
  currencyCode,
  locale,
  bed,
  bath,
  garage,
  sqft,
  lotSizeSqFt,
  house,
  sqftText,
  address,
  priceDrop,
  priceDropDate,
  type
}: any) => {
  return (
    <div className={styles.priceBox} tabIndex={4}>
      <PriceDropTag type={type} priceDrop={priceDrop} priceDropDate={priceDropDate} />
      <div className={styles.amount} tabIndex={5}>
        {formatCurrency(amount, currencyCode, locale, 0, 0)}
      </div>
      <div className={styles.address} tabIndex={6}>
        {address}
      </div>

      <ul className={styles.list} tabIndex={7}>
        {bed && (
          <li tabIndex={8}>
            <img src="/images/bed.svg" className={styles.img} alt="" />
            {bed}
          </li>
        )}
        {bath && (
          <li tabIndex={9}>
            <img src="/images/bath.svg" className={styles.img} alt="" />
            {bath}
          </li>
        )}
        {garage && (
          <li tabIndex={10}>
            <img src="/images/car.svg" className={styles.img} alt="" />
            {garage}
          </li>
        )}
        {sqft && (
          <li tabIndex={11}>
            <img src="/images/sqft.svg" className={styles.img} alt="" />
            {`${sqft} ${sqftText}`}
          </li>
        )}
        {lotSizeSqFt && (
          <li tabIndex={11}>
            <img src="/images/sqft.svg" className={styles.img} alt="" />
            {`${lotSizeSqFt} Lot Size`}
          </li>
        )}
        {house && <li tabIndex={12}>{house}</li>}
      </ul>
    </div>
  );
};

export default React.memo(PriceLayout);
